import React, { FunctionComponent, useState, KeyboardEvent} from 'react';
import Card from '../../layout/Card';
import EditIcon from '../../layout/icons/EditIcon';
import HanInput from '../../utils/HanInput';
import {ClassBuilder, useForm} from 'b302-frontend-library';
import {ReactComponent as PlusIcon} from '../../../assets/icons/icon_plus.svg';
import {ReactComponent as CheckIcon } from '../../../assets/icons/icon_check.svg';

interface Props {
    value: string;
    onChange: (value: string) => void;
    onDelete: () => void;

    children?: any;
    className?: string;
    open?: boolean;
}

const EditCard: FunctionComponent<Props> = ({ value, onChange, onDelete, children, className, open }) => {

    const [form, onChangeForm] = useForm<{ value: string }>(f => ({
        value: f.input(value)
    }));

    const [editing, setEditing] = useState<boolean>(open ?? false);

    const getClassName = () => {
        return ClassBuilder.createClass('edit-card')
            .addIf(className, className)
            .addIf('edit-card--editing', editing)
            .build();
    };

    const toggleEditing = () => {
        if(editing) {
            save();
        }

        setEditing(!editing);
    };

    const onKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
        if(e.key !== 'Enter') return;

        toggleEditing();
    };

    const save = () => onChange(form.values.value);

    const InputIcon = editing ? CheckIcon : EditIcon;

    return (
        <Card className={getClassName()}>
            <div className={'edit-card__content edit-card__content--left'}>
                { editing
                    ? <HanInput id={'value'} form={form} onChange={onChangeForm} onKeyUp={onKeyUp} />
                    : <span className={'edit-card__text'}>{ form.values.value }</span>
                }

                <div>
                    <span className={'edit-card__text'}>{ children }</span>

                    <InputIcon className={'edit-card__icon edit-card__icon--edit'} onClick={toggleEditing} />
                </div>
            </div>

            <div className={'edit-card__content--right'}>
                <div className={'edit-card__content__delete-container'}>
                    <PlusIcon className={'edit-card__icon edit-card__icon--delete'} onClick={onDelete} />
                </div>
            </div>
        </Card>
    );
};

export default EditCard;
